
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as index9yYqBaULhzMeta } from "/codebuild/output/src1856175452/src/pages/index.vue?macro=true";
import { default as aboutZYHXzQWp1nMeta } from "/codebuild/output/src1856175452/src/pages/about.vue?macro=true";
import { default as dataTRforX8hHtMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionlskMBHJRwmMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningmShieS1UIYMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyxwK7MCLifSMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account165Eb6cWGXMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueOM2bK5Yr8aMeta } from "/codebuild/output/src1856175452/src/pages/account-settings/statue.vue?macro=true";
import { default as supportyMVyUukHj9Meta } from "/codebuild/output/src1856175452/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settings064wjpK0pFMeta } from "/codebuild/output/src1856175452/src/pages/account-settings.vue?macro=true";
import { default as activate_45account8lFZ921lJ3Meta } from "/codebuild/output/src1856175452/src/pages/activate-account.vue?macro=true";
import { default as company7fyllfbsasMeta } from "/codebuild/output/src1856175452/src/pages/admin/company.vue?macro=true";
import { default as consentsIi35LoYC1nMeta } from "/codebuild/output/src1856175452/src/pages/admin/consents.vue?macro=true";
import { default as leadsAiULmBH0hGMeta } from "/codebuild/output/src1856175452/src/pages/admin/leads.vue?macro=true";
import { default as paymentsopZsWaDbDHMeta } from "/codebuild/output/src1856175452/src/pages/admin/payments.vue?macro=true";
import { default as premium6WUxDyHi2aMeta } from "/codebuild/output/src1856175452/src/pages/admin/premium.vue?macro=true";
import { default as profiles8PkIUJeMtcMeta } from "/codebuild/output/src1856175452/src/pages/admin/profiles.vue?macro=true";
import { default as userslic8H14BDiMeta } from "/codebuild/output/src1856175452/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordJZnVCdem1RMeta } from "/codebuild/output/src1856175452/src/pages/change-password.vue?macro=true";
import { default as _91id_931yxeNWzHUuMeta } from "/codebuild/output/src1856175452/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientbbuKyhSFcKMeta } from "/codebuild/output/src1856175452/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src1856175452/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexICpx36hkEXMeta } from "/codebuild/output/src1856175452/src/pages/chat/index.vue?macro=true";
import { default as _91id_938HdfChCH83Meta } from "/codebuild/output/src1856175452/src/pages/client/profile/[id].vue?macro=true";
import { default as index6mOUn4IGrFMeta } from "/codebuild/output/src1856175452/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93BrjjwJAOBgMeta } from "/codebuild/output/src1856175452/src/pages/contacts/[id].vue?macro=true";
import { default as indexnsKA1VWszmMeta } from "/codebuild/output/src1856175452/src/pages/contacts/index.vue?macro=true";
import { default as contacts2aDmXA6FMmMeta } from "/codebuild/output/src1856175452/src/pages/contacts.vue?macro=true";
import { default as _91userId_93nH7aGegveZMeta } from "/codebuild/output/src1856175452/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexqMvT7IyTjCMeta } from "/codebuild/output/src1856175452/src/pages/login/index.vue?macro=true";
import { default as register_45successujSh5C7NCVMeta } from "/codebuild/output/src1856175452/src/pages/login/register-success.vue?macro=true";
import { default as login8t6w2ppOmiMeta } from "/codebuild/output/src1856175452/src/pages/login.vue?macro=true";
import { default as logoutvimcxWNE7JMeta } from "/codebuild/output/src1856175452/src/pages/logout.vue?macro=true";
import { default as consentspoXTeIO6dEMeta } from "/codebuild/output/src1856175452/src/pages/manager/consents.vue?macro=true";
import { default as integrationsVyygaPmWKlMeta } from "/codebuild/output/src1856175452/src/pages/manager/integrations.vue?macro=true";
import { default as leadsP54BPurbRnMeta } from "/codebuild/output/src1856175452/src/pages/manager/leads.vue?macro=true";
import { default as paymentsDbqMrHGg3hMeta } from "/codebuild/output/src1856175452/src/pages/manager/payments.vue?macro=true";
import { default as profileLo42GsZY6HMeta } from "/codebuild/output/src1856175452/src/pages/manager/profile.vue?macro=true";
import { default as teamgbhr9aeWEkMeta } from "/codebuild/output/src1856175452/src/pages/manager/team.vue?macro=true";
import { default as indexSO8UsemhkQMeta } from "/codebuild/output/src1856175452/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientnwcBErsJ8TMeta } from "/codebuild/output/src1856175452/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplaceJqhjXwn3QyMeta } from "/codebuild/output/src1856175452/src/pages/marketplace.vue?macro=true";
import { default as subscribe5wAGr5g0MxMeta } from "/codebuild/output/src1856175452/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientDAJH11pJ1IMeta } from "/codebuild/output/src1856175452/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientmLgGmoayXJMeta } from "/codebuild/output/src1856175452/src/pages/orders/my.client.vue?macro=true";
import { default as privacyKaQlGix4GZMeta } from "/codebuild/output/src1856175452/src/pages/privacy.vue?macro=true";
import { default as indexlLtAHyjV3oMeta } from "/codebuild/output/src1856175452/src/pages/recover/index.vue?macro=true";
import { default as successv7Mrj2EJxYMeta } from "/codebuild/output/src1856175452/src/pages/register/success.vue?macro=true";
import { default as _91id_93Ufe36WLS3pMeta } from "/codebuild/output/src1856175452/src/pages/sales/profile/[id].vue?macro=true";
import { default as index4dKPcc3uIQMeta } from "/codebuild/output/src1856175452/src/pages/sales/profile/index.vue?macro=true";
import { default as statuezUWMkLLW8QMeta } from "/codebuild/output/src1856175452/src/pages/statue.vue?macro=true";
import { default as successfgJFVE3JdLMeta } from "/codebuild/output/src1856175452/src/pages/subscription/success.vue?macro=true";
import { default as component_45stub6co1K4PFvxMeta } from "/codebuild/output/src1856175452/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6co1K4PFvx } from "/codebuild/output/src1856175452/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index9yYqBaULhzMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutZYHXzQWp1nMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutZYHXzQWp1nMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settings064wjpK0pFMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settings064wjpK0pFMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src1856175452/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45account8lFZ921lJ3Meta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45account8lFZ921lJ3Meta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: company7fyllfbsasMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: company7fyllfbsasMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsIi35LoYC1nMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsIi35LoYC1nMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsAiULmBH0hGMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsAiULmBH0hGMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsopZsWaDbDHMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsopZsWaDbDHMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premium6WUxDyHi2aMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premium6WUxDyHi2aMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profiles8PkIUJeMtcMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profiles8PkIUJeMtcMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userslic8H14BDiMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userslic8H14BDiMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordJZnVCdem1RMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordJZnVCdem1RMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_931yxeNWzHUuMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_931yxeNWzHUuMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientbbuKyhSFcKMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientbbuKyhSFcKMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexICpx36hkEXMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexICpx36hkEXMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_938HdfChCH83Meta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_938HdfChCH83Meta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: index6mOUn4IGrFMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: index6mOUn4IGrFMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/client/profile/index.vue")
  },
  {
    name: contacts2aDmXA6FMmMeta?.name,
    path: "/en/contacts",
    meta: contacts2aDmXA6FMmMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93BrjjwJAOBgMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexnsKA1VWszmMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts2aDmXA6FMmMeta?.name,
    path: "/pl/contacts",
    meta: contacts2aDmXA6FMmMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93BrjjwJAOBgMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexnsKA1VWszmMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93nH7aGegveZMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93nH7aGegveZMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index9yYqBaULhzMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: index9yYqBaULhzMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/index.vue")
  },
  {
    name: login8t6w2ppOmiMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src1856175452/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexqMvT7IyTjCMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successujSh5C7NCVMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: login8t6w2ppOmiMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src1856175452/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexqMvT7IyTjCMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successujSh5C7NCVMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutvimcxWNE7JMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutvimcxWNE7JMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentspoXTeIO6dEMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentspoXTeIO6dEMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsVyygaPmWKlMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsVyygaPmWKlMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsP54BPurbRnMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsP54BPurbRnMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsDbqMrHGg3hMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsDbqMrHGg3hMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileLo42GsZY6HMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileLo42GsZY6HMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamgbhr9aeWEkMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamgbhr9aeWEkMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/manager/team.vue")
  },
  {
    name: marketplaceJqhjXwn3QyMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceJqhjXwn3QyMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src1856175452/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientnwcBErsJ8TMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceJqhjXwn3QyMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceJqhjXwn3QyMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src1856175452/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientnwcBErsJ8TMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribe5wAGr5g0MxMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribe5wAGr5g0MxMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientDAJH11pJ1IMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientDAJH11pJ1IMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientmLgGmoayXJMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientmLgGmoayXJMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1856175452/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyKaQlGix4GZMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyKaQlGix4GZMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexlLtAHyjV3oMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexlLtAHyjV3oMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src1856175452/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src1856175452/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93Ufe36WLS3pMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93Ufe36WLS3pMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index4dKPcc3uIQMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index4dKPcc3uIQMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuezUWMkLLW8QMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuezUWMkLLW8QMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successfgJFVE3JdLMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successfgJFVE3JdLMeta || {},
    component: () => import("/codebuild/output/src1856175452/src/pages/subscription/success.vue")
  },
  {
    name: component_45stub6co1K4PFvxMeta?.name,
    path: "/old-page",
    component: component_45stub6co1K4PFvx
  }
]